import { ReactNode } from "react"
import { Flex, Heading, Image, Text } from "@chakra-ui/react"

import superstackSuccessIcon from "#/assets/superstack-success.svg"
import TooltipLabel from "#/shared/components/TooltipLabel"

import StbtcSuccessScreen from "./StbtcSuccessScreen"

type StbtcSuccessModalProps = {
  children: ReactNode
  icon: string
  amount: string
  fullAmount: string
  amountLabel: string
  hasTooltip: boolean
}

export default function StbtcSuccessModal({
  children,
  icon,
  amount,
  fullAmount,
  amountLabel,
  hasTooltip,
}: StbtcSuccessModalProps) {
  return (
    <StbtcSuccessScreen
      header={<Heading variant="h2">{children}</Heading>}
      headerLogo={superstackSuccessIcon}
    >
      <Flex gap={5} alignItems="center">
        <Image src={icon} w="36px" />
        {hasTooltip ? (
          <TooltipLabel value={fullAmount}>
            <Heading variant="h2">
              {amount}{" "}
              <Text as="span" variant="bodyLarge">
                {amountLabel}
              </Text>
            </Heading>
          </TooltipLabel>
        ) : (
          <Heading variant="h2">
            {amount}{" "}
            <Text as="span" variant="bodyLarge">
              {amountLabel}
            </Text>
          </Heading>
        )}
      </Flex>
    </StbtcSuccessScreen>
  )
}
